// ChatUI

import * as colors from 'components/common/colorConstants';

export const chatUI = {
  toolbar: {
    background: colors.purple5,
    border: colors.purple6,
    text: colors.purple7,
    icons: {
      activeBorder: colors.purple1,
    },
  },
  content: {
    background: colors.lightGray7,
    text: colors.black4,
    border: colors.lightGray21,
    macros: {
      title: {
        selectedText: colors.purple1,
        regularText: colors.black4,
      },
      body: colors.darkGray1,
    },
  },
  buttons: {
    default: colors.baseBackground,
    useThis: colors.purple1,
    textLight: colors.baseBackground,
    textDark: colors.darkGray1,
  },
};
